import { isNil } from '@/helpers/helpers'

// https://docs.google.com/document/d/1gikjnHAtPLBqhbLfsdgT6aItgwi1gMLFKGvCUqG3BT8/edit?ts=5f9b0183#heading=h.6wfrdmg0tjof
export const traceIdHeaderKey = 'trace-id'
export const spanIdHeaderKey = 'span-id'

export type TraceId = string

export const isValidTraceId = (traceId: string): boolean => {
  return !isNil(traceId) && traceId !== 'undefined' && traceId !== 'null'
}

export const makeUniqueId = (): string => {
  let text = ''
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (let i = 0; i < 8; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}
